export const TYPE_INPUT = {
  email: 'email',
  password: 'password',
  text: 'text',
  number: 'number',
  search: 'search',
} as const;
